/**
 * Size Guide Modal - JavaScript
 * Handles modal open/close and CM/IN toggle
 */

(function () {
  'use strict';

  // DOM Elements
  const triggerLinks = document.querySelectorAll('.size-guide-trigger');
  const modal = document.getElementById('sizeGuideModal');
  const closeButtons = modal?.querySelectorAll('[data-close-modal]');
  const toggleButtons = modal?.querySelectorAll('.toggle-btn');
  const cmRows = modal?.querySelectorAll('.measurements-cm');
  const inRows = modal?.querySelectorAll('.measurements-in');

  // Open Modal
  function openModal(e) {
    e.preventDefault();
    if (modal) {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
  }

  // Close Modal
  function closeModal() {
    if (modal) {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  }

  // Toggle Units (CM/IN)
  function toggleUnits(e) {
    const unit = e.target.dataset.unit;

    // Update active button
    toggleButtons.forEach(btn => btn.classList.remove('active'));
    e.target.classList.add('active');

    // Show/hide appropriate rows
    if (unit === 'cm') {
      cmRows.forEach(row => row.style.display = '');
      inRows.forEach(row => row.style.display = 'none');
    } else {
      cmRows.forEach(row => row.style.display = 'none');
      inRows.forEach(row => row.style.display = '');
    }
  }

  // Close on Escape key
  function handleKeydown(e) {
    if (e.key === 'Escape' && modal?.classList.contains('is-open')) {
      closeModal();
    }
  }

  // Initialize
  function init() {
    // Trigger links
    triggerLinks.forEach(link => {
      link.addEventListener('click', openModal);
    });

    // Close buttons (X and overlay)
    closeButtons?.forEach(btn => {
      btn.addEventListener('click', closeModal);
    });

    // Toggle buttons
    toggleButtons?.forEach(btn => {
      btn.addEventListener('click', toggleUnits);
    });

    // Escape key
    document.addEventListener('keydown', handleKeydown);
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
